import { makeAutoObservable, runInAction } from 'mobx';
import { FilterDTO, OrganizationDTO } from '../Models/ApiModels';
import { LocalStorageSet } from '../Services/Helpers';
import { PromiseCompletion } from '../Services/PromiseCompletion';
import { ApiService } from '../Services';
import { ApiURL } from '../AppConstants';
import { getSelectOptions, Option } from '../Components/Select/Select';

export type SelectedFilter = {
    organization: string
}

const FILTER_STORE_KEY = 'filterState';

export class FiltersStore {
    public filters: FilterDTO = new FilterDTO();
    public selected: SelectedFilter = this.defaultFilter;
    isLoading: PromiseCompletion = new PromiseCompletion();

    constructor () {
        makeAutoObservable(this);
    }

    public async getData () {
        await this._getOrganizations();
    }

    private async _getOrganizations () {
            const { data } = await ApiService.getData<OrganizationDTO[]>(ApiURL.Organizations, null, { completion: this.isLoading });

            runInAction(() => {

                this.filters.organizations = data;
            });
    }

    public get selectedOrganizationOption () {
        return this.organizationOptions.find(o => o.value === this.selected.organization);
    }

    public get organizationOptions (): Option[] {
        return getSelectOptions<OrganizationDTO>(this.filters?.organizations || [], 'name', 'id');
    }

    public onOrganizationsChange = (selected: string) => {
        const newFilters = this.defaultFilter;
        newFilters.organization = selected;
        this.onFilterChange(newFilters);
    };

    public get defaultFilter () {
        return {
            organization: '',
        };
    }

    public restoreState () {
        // const hasValue = LocalStorageGet<SelectedFilter>(FILTER_STORE_KEY);

        // if (hasValue && this.customerOptions.find(e => e.value === hasValue.customer)) {
        //     this.selected = hasValue;
        //     if (this.selected.customer) {
        //         // void this._getDevices();
        //     }
        // }
        // if (!this.selected.customer && this.customerOptions.length) {
        //     this.onCustomerChange(this.customerOptions[0].value);
        // }
    }

    public storeValue () {
        LocalStorageSet(FILTER_STORE_KEY, this.selected);
    }

    public onFilterChange (newFilters: SelectedFilter) {
        this.selected = newFilters;
        this.storeValue();
    }

}